import { useContext } from 'react';
import { useLocalStore } from 'mobx-react';
import { useConfig } from '@ibe/components';
import CmsDealFinderGlobalConfigService from '../Services/CmsDealFinderGlobalConfigService';
import CmsDealFinderGlobalConfigContext from '../Contexts/CmsDealFinderGlobalConfigContext';

function useDealFinderGlobalConfigService(): CmsDealFinderGlobalConfigService {
  const context = useContext(CmsDealFinderGlobalConfigContext);
  const config = useConfig();
  const service: CmsDealFinderGlobalConfigService = useLocalStore<CmsDealFinderGlobalConfigService>(
    () => context
  );

  service.apiUrl = config.apiUrl;

  return service;
}

export default useDealFinderGlobalConfigService;
